import { gql, TypedDocumentNode } from '@apollo/client';
import { Mutation, MutationShareArgs } from 'sr-types/lib/note/v1/graphql';
import { ReferenceFragment } from '../../list/fragments';

export const shareMutation: TypedDocumentNode<Pick<Mutation, 'share'>, MutationShareArgs> = gql`
    mutation Share($input: ShareRequest!, $notificationInput: NotificationRequest) {
        share(input: $input, notificationInput: $notificationInput) {
            id
            errors {
                field
                key
                message
            }
            reference {
                ...Reference
            }
        }
    }
    ${ReferenceFragment}
`;
